import { z } from "zod"
import { ServiceAction } from "../service-part-action"

export const PartActionSelectionSchema = z.object({
  partId: z.string().uuid(),
  action: z.nativeEnum(ServiceAction),
})

export const AutoCalculatePricesSchema = z.object({
  priceListId: z.string().uuid(),
  hourlyPrice: z.number().int().positive(),
  selections: z.array(PartActionSelectionSchema),
})

export type PartActionSelection = z.infer<typeof PartActionSelectionSchema>
export type AutoCalculatePrices = z.infer<typeof AutoCalculatePricesSchema>
